import { useGridRootProps } from "@components/DataGrid/hooks/useGridRootProps";
import { Box } from "@mui/material";
import { unstable_composeClasses as composeClasses } from "@mui/utils";
import { GridGroupNode, GridRenderCellParams, getDataGridUtilityClass } from "@mui/x-data-grid";
import { useGridApiContext } from "@mui/x-data-grid-premium";
import { DataGridPremiumProcessedProps } from "@mui/x-data-grid-premium/models/dataGridPremiumProps";
import { MouseEvent } from "react";

type OwnerState = DataGridPremiumProcessedProps;

export const useUtilityClasses = (ownerState: OwnerState) => {
  const { classes } = ownerState;

  const slots = {
    root: ["treeDataGroupingCell"],
    toggle: ["treeDataGroupingCellToggle"],
  };

  return composeClasses(slots, getDataGridUtilityClass, classes);
};

export interface FileGridTreeDataGroupingCellFilenameProps {
  /**
   * File icon.
   * @default undefined
   */
  fileIcon?: React.ReactNode;
}

export interface BaseFileGridTreeDataGroupingCellSlots {
  /**
   * The component that renders the filename.
   * @default undefined
   */
  fileName?: FileGridTreeDataGroupingCellFilenameProps;
}

export interface FileGridTreeDataGroupingCellProps extends GridRenderCellParams<any, any, any, GridGroupNode> {
  /**
   * The cell offset multiplier used for calculating cell offset (`rowNode.depth * offsetMultiplier` px).
   * @default 2
   */
  offsetMultiplier?: number;
  /**
   * The slots containing the components to render.
   */
  slots?: BaseFileGridTreeDataGroupingCellSlots;
}

export const FilesGridTreeDataGroupingCell = (props: FileGridTreeDataGroupingCellProps) => {
  const { id, field, formattedValue, rowNode, offsetMultiplier = 2 } = props;

  const rootProps = useGridRootProps();
  const apiRef = useGridApiContext();
  const classes = useUtilityClasses(rootProps);

  // TODO: add a property for this
  const showExpander = rowNode.type === "group";

  let Icon = rowNode.childrenExpanded ? rootProps.slots.treeDataCollapseIcon : rootProps.slots.treeDataExpandIcon;

  const handleClick = (event: MouseEvent<HTMLButtonElement>) => {
    apiRef.current.setRowChildrenExpansion(id, !rowNode.childrenExpanded);
    apiRef.current.setCellFocus(id, field);
    event.stopPropagation();
  };

  //console.log('formattedValue: ', formattedValue, props);
  return (
    <Box className={classes.root} sx={{ ml: rowNode.depth * offsetMultiplier }}>
      <div className={classes.toggle}>
        {showExpander === true && (
          <rootProps.slots.baseIconButton
            size="small"
            onClick={handleClick}
            tabIndex={-1}
            aria-label={rowNode.childrenExpanded ? apiRef.current.getLocaleText("treeDataCollapse") : apiRef.current.getLocaleText("treeDataExpand")}
            {...rootProps?.slotProps?.baseIconButton}
          >
            <Icon fontSize="inherit" />
          </rootProps.slots.baseIconButton>
        )}
      </div>
      <Box sx={{ display: "flex", alignItems: "center" }}>
        {props.slots?.fileName?.fileIcon}
        {formattedValue === undefined ? rowNode.groupingKey : formattedValue}
      </Box>
    </Box>
  );
};

/*
      <Box sx={{ display: "flex", alignItems: "center" }}>
      {props.slots?.fileName?.fileIcon}
        {formattedValue === undefined ? rowNode.groupingKey : formattedValue}
        </Box>
 */
